import { Transport } from "./types";

export type Organism = { [key: string]: Transport<any> }
export const organism: Organism = {}


